import sanitizeHtml from 'sanitize-html'

export function numberWithDelimiter(num) {
  let str = new String(num)
  while (str != (str = str.replace(/^(-?\d+)(\d{3})/, '$1,$2')));
  return str
}

export function checkEmailAddress(str) {
  if (str.match(/.+@.+\..+/)) {
    return true
  } else {
    return false
  }
}

export function encodeURIPath(str, isReplacePeriod = true) {
  if (!str) return null

  if (isReplacePeriod) {
    // periodを半角スペースに置き換え
    str = str.replace(/\./g, ' ')
  }
  return encodeURIComponent(str)
}

export function checkPassword(str) {
  return str.match(/^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?\d)[!-~]{8,100}$/i)
}

export function RenderHtml({ htmlContent }) {
  const html = sanitizeHtml(htmlContent, {
    allowedTags: ['b', 'br'], // 許可するタグ
    allowedAttributes: {}, // 属性はすべて禁止
    disallowedTagsMode: 'discard', // 不許可タグは完全削除
    selfClosing: ['br'], // 自己閉じタグとして処理
  })

  return <div dangerouslySetInnerHTML={{ __html: html }} />
}
